import { apiClient } from './client';

export function createProduct (shopId: number | string, payload: Record<string, unknown>) {
  return apiClient.post(`/${shopId}/return-coverage/products`, payload);
}

export function publishConfig (shopId: number | string) {
  return apiClient.post(`/${shopId}/offset/publish-config`);
}

export function getOrderProtectionConfig (shopId: number | string) {
  return apiClient.get(`/${shopId}/order-protection`);
}
